import * as AuthActions from './auth.action';
import { Action, createReducer, on } from '@ngrx/store';

export const initialState: any = {
  loading: false,
  isAuthenticated: false,
  user: null,
  errorMessage: null
};

export interface State {
  loading: boolean;
  isAuthenticated: boolean;
  userAuth: any | null;
  errorMessage: string | null;
}

const authReducer = createReducer(
  initialState,
  on(AuthActions.LoginRequest, (state, { username, password, dbName }) => ({
    ...state,
    loading: true,
    isAuthenticated: false,
    userAuth: null,
    errorMessage: null
  })),
  on(AuthActions.LoginSuccess, (state, { userAuth }) => ({
    ...state,
    loading: false,
    userAuth,
    errorState: null
  })),
  on(AuthActions.LoginFailure, (state, { errorState }) => ({
    ...state,
    loading: false,
    userAuth: null,
    errorState
  }))
);

export function AuthReducer(state: any | undefined, action: Action) {
  return authReducer(state, action);
}
